// How auto-design chooses among the valid designs. Mirrors
// pv_core/design_capacity.py RANKING_DEFAULTS; the PV sizing reads the same
// three project keys (autoDesign.*).
export const RANKING_DEFAULTS = { preferNearestStrict: true, preferFewerInverters: true, withinCurrentRatings: false };
